// extracted by mini-css-extract-plugin
module.exports = {"panel-border":"styles-module__panel-border___rrZYR"};